import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import logo from "@/assets/logo.png";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b border-border">
        <div className="container mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
            <img src={logo} alt="Memo" className="h-8 w-8 rounded-lg" />
            <span className="text-xl font-semibold">Memo</span>
          </div>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center">
        <div className="text-center space-y-6 px-6">
          <h1 className="text-6xl sm:text-8xl font-bold text-muted-foreground">404</h1>
          <h2 className="text-xl sm:text-2xl font-semibold">Page not found</h2>
          <p className="text-muted-foreground max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={() => navigate("/")}>
              <Home className="h-4 w-4 mr-2" />
              Go home
            </Button>
            <Button variant="outline" onClick={() => navigate("/app")}>
              Go to dashboard
            </Button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-border py-4">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          Built by{" "}
          <a
            href="https://bwestudios.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-foreground hover:text-primary transition-smooth"
          >
            BWE Studio
          </a>
        </div>
      </footer>
    </div>
  );
};

export default NotFound;